import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const FeaturedParts = ({ parts, onViewAll }) => {
  const formatPrice = (price) => {
    return new Intl.NumberFormat('id-ID', {
      style: 'currency',
      currency: 'IDR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    })?.format(price);
  };

  return (
    <div className="bg-gradient-to-br from-primary/5 to-accent/5 rounded-lg p-4 md:p-6 lg:p-8">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center space-x-3">
          <div className="w-12 h-12 bg-primary rounded-lg flex items-center justify-center shadow-honda-glow">
            <Icon name="Star" size={24} color="white" />
          </div>
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground">
              Part Unggulan
            </h2>
            <p className="text-sm text-muted-foreground">
              Part terpopuler dan paling dicari
            </p>
          </div>
        </div>
        <Button
          variant="outline"
          size="default"
          iconName="ArrowRight"
          iconPosition="right"
          onClick={onViewAll}
          className="hidden md:flex"
        >
          Lihat Semua
        </Button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
        {parts?.slice(0, 3)?.map((part) => (
          <div
            key={part?.id}
            className="bg-card rounded-lg overflow-hidden shadow-card-hover hover:shadow-honda-glow transition-all duration-300 group"
          >
            <div className="relative h-40 md:h-48 overflow-hidden bg-muted">
              <Image
                src={part?.image}
                alt={part?.imageAlt}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute top-3 left-3 bg-primary text-primary-foreground px-3 py-1 rounded-full flex items-center space-x-1 shadow-honda-subtle">
                <Icon name="TrendingUp" size={14} />
                <span className="text-xs font-heading font-bold">Populer</span>
              </div>
            </div>

            <div className="p-4">
              <h3 className="text-base font-heading font-bold text-foreground mb-2 line-clamp-1">
                {part?.name}
              </h3>
              <p className="text-lg font-heading font-bold text-primary mb-3">
                {formatPrice(part?.price)}
              </p>
              <div className="flex items-center justify-between text-xs text-muted-foreground">
                <span className="flex items-center space-x-1">
                  <Icon name="Package" size={14} />
                  <span>{part?.partCode}</span>
                </span>
                <span className="flex items-center space-x-1">
                  <Icon name="CheckCircle" size={14} color="var(--color-success)" />
                  <span className="text-success font-medium">Tersedia</span>
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
      <Button
        variant="outline"
        size="lg"
        fullWidth
        iconName="ArrowRight"
        iconPosition="right"
        onClick={onViewAll}
        className="mt-6 md:hidden"
      >
        Lihat Semua Part Unggulan
      </Button>
    </div>
  );
};

export default FeaturedParts;